import { render, staticRenderFns } from "./GridAmount.vue?vue&type=template&id=384f870b&"
import script from "./GridAmount.vue?vue&type=script&lang=js&"
export * from "./GridAmount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports